export default __webpack_public_path__ + "static/media/milk-img.a55d38c7.png";